import React from 'react';
import templateIds from '../../../constants/templates.constants';
import useSitecoreContext from '../../../hooks/useSitecoreContext';
import Picture from '../../@shared/picture';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import { useMenuDispatcher } from '../menuContext';

const Logo = ({ fields }): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();

  const dispatch = useMenuDispatcher();
  const handleClick = (): void => {
    dispatch({ type: 'closeAll' });
  };

  const isHomePage = sitecoreContext?.route?.templateId === templateIds.homeTemplateId;

  const LogoTag = isHomePage ? 'h1' : 'span';

  const brandLogoImageData = sitecoreContext?.defaultBackgroundImageParametersV2;
  const altText = brandLogoImageData?.desktopImageData?.logoImage?.value?.alt;

  return (
    <LogoTag className="navigation__logo">
      <RoutableSitecoreLink className="navigation__logo__link" field={fields.logolink} onClick={handleClick} editable={false}>
        <Picture
          editorialImageProps={{
            desktopImage: brandLogoImageData?.desktopImageData?.logoImage,
            mobileImage: brandLogoImageData?.mobileImageData?.logoImage,
            desktopTransformation: 'Size200',
            mobileTransformation: 'Size200',
            cssClassImageEl: 'navigation__logo__image',
            prioritize: true,
            alt: altText,
          }}
        />
      </RoutableSitecoreLink>
    </LogoTag>
  );
};

export default Logo;
